"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _Theme = require("../../../Theme/Theme.variables");

var _IconBase = require("./IconBase");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Instagram =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Instagram, _PureComponent);

  function Instagram() {
    _classCallCheck(this, Instagram);

    return _possibleConstructorReturn(this, _getPrototypeOf(Instagram).apply(this, arguments));
  }

  _createClass(Instagram, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          height = _this$props.height,
          width = _this$props.width;
      var color = (0, _Theme.variables)(this.props)[this.props.color];
      return _react.default.createElement(_IconBase.IconBase, _extends({
        width: width,
        height: height,
        className: className,
        style: style,
        viewBox: "0 0 17 16",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, this.props), _react.default.createElement("title", null, "Instagram"), _react.default.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, _react.default.createElement("g", {
        fill: color
      }, _react.default.createElement("path", {
        d: "M8.5,0 C10.673,0 10.945,0.009 11.799,0.048 C12.65,0.087 13.231,0.223 13.74,0.42 C14.267,0.624 14.713,0.898 15.157,1.343 C15.602,1.787 15.876,2.233 16.08,2.76 C16.277,3.269 16.413,3.85 16.452,4.701 C16.491,5.555 16.5,5.827 16.5,8 C16.5,10.173 16.491,10.445 16.452,11.299 C16.413,12.15 16.277,12.731 16.08,13.24 C15.876,13.767 15.602,14.213 15.157,14.657 C14.713,15.102 14.267,15.376 13.74,15.58 C13.231,15.777 12.65,15.913 11.799,15.952 C10.945,15.991 10.673,16 8.5,16 C6.327,16 6.055,15.991 5.202,15.952 C4.35,15.913 3.769,15.777 3.26,15.58 C2.733,15.376 2.288,15.102 1.843,14.657 C1.398,14.213 1.125,13.767 0.92,13.24 C0.722,12.731 0.587,12.15 0.548,11.299 C0.509,10.445 0.5,10.173 0.5,8 C0.5,5.827 0.509,5.555 0.548,4.701 C0.587,3.85 0.722,3.269 0.92,2.76 C1.125,2.233 1.398,1.787 1.843,1.343 C2.288,0.898 2.733,0.624 3.26,0.42 C3.769,0.223 4.35,0.087 5.202,0.048 C6.055,0.009 6.327,0 8.5,0 Z M8.5,1.441 C6.364,1.441 6.111,1.449 5.267,1.488 C4.487,1.523 4.064,1.654 3.782,1.764 C3.408,1.908 3.142,2.082 2.862,2.362 C2.582,2.642 2.409,2.908 2.264,3.282 C2.154,3.563 2.023,3.987 1.988,4.768 C1.95,5.611 1.941,5.864 1.941,8 C1.941,10.136 1.95,10.389 1.988,11.232 C2.023,12.013 2.154,12.437 2.264,12.718 C2.409,13.092 2.582,13.358 2.862,13.638 C3.142,13.918 3.408,14.092 3.782,14.236 C4.064,14.346 4.487,14.477 5.267,14.512 C6.111,14.551 6.364,14.559 8.5,14.559 C10.636,14.559 10.889,14.551 11.732,14.512 C12.513,14.477 12.937,14.346 13.218,14.236 C13.592,14.092 13.858,13.918 14.138,13.638 C14.418,13.358 14.592,13.092 14.736,12.718 C14.846,12.437 14.977,12.013 15.012,11.232 C15.051,10.389 15.059,10.136 15.059,8 C15.059,5.864 15.051,5.611 15.012,4.768 C14.977,3.987 14.846,3.563 14.736,3.282 C14.592,2.908 14.418,2.642 14.138,2.362 C13.858,2.082 13.592,1.908 13.218,1.764 C12.937,1.654 12.513,1.523 11.732,1.488 C10.889,1.449 10.636,1.441 8.5,1.441 Z M8.5,10.667 C9.973,10.667 11.167,9.473 11.167,8 C11.167,6.527 9.973,5.333 8.5,5.333 C7.027,5.333 5.833,6.527 5.833,8 C5.833,9.473 7.027,10.667 8.5,10.667 Z M8.5,3.892 C10.769,3.892 12.608,5.731 12.608,8 C12.608,10.269 10.769,12.108 8.5,12.108 C6.231,12.108 4.392,10.269 4.392,8 C4.392,5.731 6.231,3.892 8.5,3.892 Z M13.7305,3.7295 C13.7305,4.2595 13.3005,4.6895 12.7705,4.6895 C12.2405,4.6895 11.8105,4.2595 11.8105,3.7295 C11.8105,3.1995 12.2405,2.7695 12.7705,2.7695 C13.3005,2.7695 13.7305,3.1995 13.7305,3.7295 Z"
      }))));
    }
  }]);

  return Instagram;
}(_react.PureComponent);

Instagram.displayName = 'Instagram'; // Prop Types

Instagram.propTypes = {
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  width: _propTypes.default.string,
  height: _propTypes.default.string,
  color: _propTypes.default.string
};
Instagram.defaultProps = {
  className: '',
  style: {},
  height: '16',
  width: '17',
  color: 'black'
};

var _default = (0, _styledComponents.withTheme)(Instagram);

exports.default = _default;